import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import RoomIcon from '../../../Icons/Room'
import Container from '../Container'

interface RoomButtonProps {
    size?: number
    color?: string
    shadow?: boolean
    filled?: boolean
    title?: string
    onClick?: any
}

const RoomButton = memo((props: RoomButtonProps) => {
    const { shadow, title, size, color, filled, onClick } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton onClick={onClick} title={title}>
                <RoomIcon color={color ?? '#eee'} size={size} filled={filled} />
            </IconButton>
        </Container>
    )
})

export default RoomButton
